import React from 'react';
import classnames from 'classnames';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/action-list-notes';
import { getLabel } from 'utils/getLabel';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { actionWidgetNotes as ActionWidgetNotes } from 'ui/views/widgets/actionWidgetNotes';
 *
 * // render
 * <ActionWidgetNotes propName='propValue'/>
 */
export const actionWidgetNotesSuccess = ( props ) => {
    
    return (
        <div className='ui-action-widget-notes'>
            <div className='ui-action-widget-notes__title'>
                { getLabel( props.componentData.structure.title ) }
            </div>
            <TableSearchWidget
                templateType='inline'
                layoutConfig={ layoutConfig }
                tableResponse={ props.componentData }
                disablePagination={ true }
            />
        </div>
    );
};

// set display name
actionWidgetNotesSuccess.displayName = 'actionWidgetNotesSuccess';

// set default props
actionWidgetNotesSuccess.defaultProps = {};

// prop types
actionWidgetNotesSuccess.propTypes = {};

/*******************************/
// preloader view
const actionWidgetNotesPreloader = ( props ) => {
    
    // widget class name
    const widgetClassName = classnames( 'ui-action-widget-notes-preloader', props.className );
    return (
        <div className={ widgetClassName }>
            <TableSearchInlineWidgetPreloader />
        </div>
    );
};

// set display name
actionWidgetNotesPreloader.displayName = 'actionWidgetNotesPreloader';

// set default props
actionWidgetNotesPreloader.defaultProps = {};

// prop types
actionWidgetNotesPreloader.propTypes = {};

/*******************************/

export const actionWidgetNotes = withNetworkState( actionWidgetNotesPreloader, actionWidgetNotesSuccess );
